import { InsuranceCompanyAdapter } from './reducer'

export const {
  selectAll: selectAllInsuranceCompanies,
  selectById: selectInsuranceCompanyById,
} = InsuranceCompanyAdapter.getSelectors(state => state.insuranceCompanies)
